import { Action } from '@ngrx/store';
// import { IUser, Login } from '../../models';
import { User } from '../../Models/User'


export enum EUserActions {
    LoginUser = '[User] Login User',
    LoginUserSuccess = '[User] Login User Success',
    LoginUserError = '[User] Login User Error',
//     SetSucessMessage = '[User] Set Success Message',
    SetErrorMessage = '[User] Set Error Message',
//     SetUserDetails = '[User] Set User Details',
//     UpdateUserDetail = '[User] Update User Details',
//     UploadProfileImage = '[User] Upload Profile Image',
//     UploadProfileImageSuccess = '[User] Upload Profile Image Success',
//     UpdateUserDetailSuccess = '[User] Update UserDetail Success',
//     CreateUser = '[User] Create User',
//     GetAllAdminUsers = '[User] Get All Admin Users',
//     GetAllAdminUsersSuccess = '[User] Get All Admin Users Success',
//     GetAdminDetails = '[User] Get AdminDetails',
//     GetAdminDetailsSuccess = '[User] Get AdminDetails Success',
//     EditAdminDetails = '[User] Edit Admin Details'
    SendLinkForForgotPswd = '[User] Check Username',
    SendLinkForForgotPswdSuccess = '[User] Set Check Username Success',
    SendLinkForForgotPswdError = '[User] Set Check Username Error',
    ResetPassword = '[User] Reset Password',
    ResetPasswordSuccess = '[User] Set Reset password Success',
    ResetPasswordError = '[User] Set Reset password Error',
    UpdateTerms ='[User] Get Update Terms',
    UpdateTermsSucces = '[User] Set Update Terms Success',
    UpdateTermsError = '[User] Set Update Terms Error',
    CheckPswdLink = '[User] Check Pswd Link',
    CheckPswdLinkSuccess = '[User] Check Pswd Link Success',
    CheckPswdLinkError = '[User] Check Pswd Link Error',
    ResetPasswordByLink = '[User] Reset Password By Link',
    ResetPasswordByLinkSuccess = '[User] Set Reset password By Link Success',
    ResetPasswordByLinkError = '[User] Set Reset password By Link Error',


}
export class LoginUser implements Action {
    public readonly type = EUserActions.LoginUser;
    constructor(public payload: any) { }
}
export class LoginUserSuccess implements Action {
    public readonly type = EUserActions.LoginUserSuccess;
    constructor(public payload: User) { }
}

export class LoginUserError implements Action {
    public readonly type = EUserActions.LoginUserError;
    constructor(public payload: any) {
     }
}

export class SetErrorMessage implements Action {
    public readonly type = EUserActions.SetErrorMessage;
    constructor(public payload: any, public store: any) {
        store.dispatch(new LoginUserError(payload))
     }
}
export class SendLinkForForgotPswd implements Action {
    public readonly type = EUserActions.SendLinkForForgotPswd;
    constructor(public payload: any) { }
}

export class SendLinkForForgotPswdSuccess implements Action {
    public readonly type = EUserActions.SendLinkForForgotPswdSuccess;
    constructor(public payload: any) { }
}

export class SendLinkForForgotPswdError implements Action {
    public readonly type = EUserActions.SendLinkForForgotPswdError;
    constructor(public payload: any) { }
}

export class ResetPassword implements Action {
    public readonly type = EUserActions.ResetPassword;
    constructor(public payload: any) { }
}

export class ResetPasswordSuccess implements Action {
    public readonly type = EUserActions.ResetPasswordSuccess;
    constructor(public payload: any) { }
}

export class ResetPasswordError implements Action {
    public readonly type = EUserActions.ResetPasswordError;
    constructor(public payload: any) { }
}
export class UpdateTerms implements Action {
    public readonly type = EUserActions.UpdateTerms;
    constructor(public payload: any){ }
}
export class UpdateTermsSucces implements Action {
    public readonly type = EUserActions.UpdateTermsSucces;
    constructor(public payload: any) {}
}
export class UpdateTermsError implements Action {
    public readonly type = EUserActions.UpdateTermsError;
    constructor(public payload: any) {}
}
export class CheckPswdLink implements Action {
    public readonly type = EUserActions.CheckPswdLink;
    constructor(public payload: any) {}
}
export class CheckPswdLinkSuccess implements Action {
    public readonly type = EUserActions.CheckPswdLinkSuccess;
    constructor(public payload: any) {}
}
export class CheckPswdLinkError implements Action {
    public readonly type = EUserActions.CheckPswdLinkError;
    constructor(public payload: any) {}
}
export class ResetPasswordByLink implements Action {
    public readonly type = EUserActions.ResetPasswordByLink;
    constructor(public payload: any) {}
}
export class ResetPasswordByLinkSuccess implements Action {
    public readonly type = EUserActions.ResetPasswordByLinkSuccess;
    constructor(public payload: any) {}
}
export class ResetPasswordByLinkError implements Action {
    public readonly type = EUserActions.ResetPasswordByLinkError;
    constructor(public payload: any) {}
}

// export class UpdateTermsError implements Action  {
//     public readonly type = EUserActions.UpdateTermsError;
//     constructor(public payload: any){ }

    
// }

// export class GetAllAdminUsersSuccess implements Action {
//     public readonly type = EUserActions.GetAllAdminUsersSuccess;
//     constructor(public payload: any) { }
// }
// export class GetAdminDetails implements Action {
//     public readonly type = EUserActions.GetAdminDetails;
//     constructor(public payload: any) { }
// }
// export class GetAdminDetailsSuccess implements Action {
//     public readonly type = EUserActions.GetAdminDetailsSuccess;
//     constructor(public payload: any) { }
// }

// export class EditAdminDetails implements Action {
//     public readonly type = EUserActions.EditAdminDetails;
//     constructor(public payload: any) { }
// }



// // tslint:disable-next-line:max-line-length
export type UserActions = LoginUser | LoginUserSuccess | LoginUserError | SetErrorMessage |
                        SendLinkForForgotPswd | SendLinkForForgotPswdSuccess | SendLinkForForgotPswdError |
                        ResetPassword | ResetPasswordSuccess | ResetPasswordError | UpdateTerms | UpdateTermsSucces |
                        UpdateTermsError | CheckPswdLink | CheckPswdLinkSuccess | CheckPswdLinkError | ResetPasswordByLink | 
                        ResetPasswordByLinkSuccess | ResetPasswordByLinkError;
//     SetSucessMessage | SetUserDetails | CreateUser | GetAllAdminUsers | GetAllAdminUsersSuccess |
//     EditAdminDetails | GetAdminDetails | GetAdminDetailsSuccess;



